import React from "react";
import "./RatesSection.css";

const rates = [
  { card: "Visa Card", rate: "1.79%", accent: "hsl(217 91% 60%)", class: "visa" },
  { card: "RuPay Card", rate: "1.98%", accent: "hsl(142 71% 45%)", class: "rupay" },
  { card: "MasterCard", rate: "1.98%", accent: "hsl(25 95% 53%)", class: "mastercard" },
];

const RatesSection = () => {
  return (
    <section id="rates" className="rates-section">
      <div className="rates-container">
        
        <div className="rates-header fade-in-up">
          <h2 className="rates-title gold-gradient-text">Unbeatable Rates</h2>
          <p className="rates-subtitle">(Expected HDFC Card rates)</p>
        </div>

        <div className="rates-grid">
          {rates.map((r, i) => (
            <div 
              key={r.card} 
              className={`rate-card-wrapper fade-in-up ${r.class}`}
              style={{ 
                animationDelay: `${i * 0.15}s`,
                "--accent-color": r.accent 
              }}
            >
              <div className="rate-card-inner">
                <div className="rate-card-content">
                  <p className="card-name">{r.card}</p>
                  <p className="card-rate gold-gradient-text">{r.rate}</p>
                  <p className="rate-label">per transaction</p>
                </div>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default RatesSection;